import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Box,
  Button,
  Drawer,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import Header from "../../component/Header";
import {
  updateDetailsAction,
  fetchDetailAction,
  resetState,
} from "../../state/ingredientsExtras/ingredientsExtrasSlice"; // Update import statements
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import Loader from "../../component/loader";

const EditExtras = ({ open, handleClose, id }) => {
  const theme = useTheme();
  const dispatch = useDispatch();


  const loading = useSelector((state) => state.ingredientsExtras.loading);
  const ingredientsExtras = useSelector(
    (state) => state.ingredientsExtras.data
  );
  const isSuccess = useSelector((state) => state?.ingredientsExtras.isSuccess);
  const Updated = useSelector((state) => state?.ingredientsExtras.Updated);
  const appErr = useSelector((state) => state.ingredientsExtras.appErr);

  useEffect(() => {
    if (id) {
      dispatch(fetchDetailAction(id));
    }
  }, [dispatch, id, isSuccess]);

  useEffect(() => {
    if (isSuccess && Updated) {
      toast.success("Details Edited Successfully!");
    }
  }, [isSuccess, Updated]);

  useEffect(() => {
    if (appErr) {
      toast.error(appErr);
    }
  }, [appErr]);

  // Define validation schema
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    type: Yup.string().required(" Type is required"),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: ingredientsExtras?.name || "", // Ensure that the initial value is not undefined
      type: ingredientsExtras?.type || "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      const data = {
        name: values?.name,
        type: values?.type,
      };
      dispatch(updateDetailsAction({ data, id }));
      console.log(values);
      handleClose();
      setSubmitting(false);
      setTimeout(() => {
        dispatch(resetState());
      }, 3000);
    },
  });

  return (
    <React.Fragment>
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        style={{ zIndex: "9999 " }} // Default width
        PaperProps={{
          sx: {
            width: "40%", // Default width
            "@media (max-width: 700px)": {
              width: "70%", // Width set to 70% for screens <= 700px
            },
          },
        }}
      >
        <form onSubmit={formik.handleSubmit}>
          <Box m="1.5rem 2.5rem">
            <Box mb="1rem">
              <Header
                title="Ingredients Extras Details"
                subtitle="Add New Extras"
              />
            </Box>
            <Grid container>
              <Grid item xs={12} md={12}>
                <Box
                  p={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Extras Name :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Name: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    id="name"
                    name="name"
                    label="Name"
                    variant="outlined"
                    fullWidth
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={formik.touched.name && formik.errors.name}
                    style={{ marginTop: "25px", width: "100%" }}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={12}>
                <Box
                  mt={3}
                  p={2}
                  mb={2}
                  borderRadius={4}
                  bgcolor={theme.palette.background.default}
                  boxShadow={theme.shadows[3]}
                >
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    Extras Type :
                  </Typography>
                  <hr
                    style={{ border: "1px solid #f0f0f0", margin: "10px 0" }}
                  />
                  <Typography variant="h6" gutterBottom>
                    Type: <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    id="type"
                    name="type"
                    label="Type"
                    variant="outlined"
                    fullWidth
                    value={formik.values.type}
                    onChange={formik.handleChange}
                    error={formik.touched.type && Boolean(formik.errors.type)}
                    helperText={formik.touched.type && formik.errors.type}
                    style={{ marginTop: "25px", width: "100%" }}
                  />
                </Box>
              </Grid>
            </Grid>

            <Button
              onClick={handleClose}
              variant="contained"
              color="secondary"
              size="small"
              style={{ marginRight: "5px" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="secondary"
              disabled={loading}
              size="small"
            >
              {!loading ? "Submit" : <Loader />}
            </Button>
          </Box>
        </form>
      </Drawer>
    </React.Fragment>
  );
};

export default EditExtras;
